import { useAuth } from 'oidc-react';

export type OidcUserInfo = {
  given_name?: string;
  name?: string;
  email?: string;
};

export function useOidcUser(): { oidcUser?: OidcUserInfo; isLoading: boolean } {
  const { userData, isLoading } = useAuth();

  return {
    isLoading,
    oidcUser:
      !isLoading && userData?.profile
        ? {
            given_name: userData.profile.given_name,
            name: userData.profile.name,
            email: userData.profile.email,
          }
        : undefined,
  };
}

export function useToken() {
  const { userData } = useAuth();

  return { accessToken: userData?.access_token };
}
